import React, { useEffect, useRef, useState } from 'react';
import styles from './HideColumns.module.css';
import CheckList from '../CheckList/CheckList';

const HideColumns = ({
  columns,
  tableRef,
  columnVisibility,
  setColumnVisibility,
}) => {
  // ✅ Ako `columnVisibility` nije prosleđen iz parenta, koristi interni `useState`
  const [internalColumnVisibility, setInternalColumnVisibility] = useState({});
  const isUsingInternalState = !columnVisibility || !setColumnVisibility;

  const finalColumnVisibility = isUsingInternalState
    ? internalColumnVisibility
    : columnVisibility;
  const updateColumnVisibility = isUsingInternalState
    ? setInternalColumnVisibility
    : setColumnVisibility;

  const [columnsValues, setColumnsValues] = useState([]);
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  // ✅ Inicijalno postavljanje stanja kolona
  useEffect(() => {
    if (Object.keys(finalColumnVisibility).length === 0) {
      const initialVisibility = {};

      columns.forEach((col) => {
        initialVisibility[col.field] = col.hide || false;
      });

      updateColumnVisibility(initialVisibility);
    }
  }, [columns, updateColumnVisibility, finalColumnVisibility]);

  useEffect(() => {
    if (Object.keys(finalColumnVisibility).length > 0) {
      // Postavi vrednosti za checkbox listu
      const valueList = columns.map((item) => ({
        name: item.field,
        title: item.title,
        value: !finalColumnVisibility[item.field], // Obrnuta logika jer `true` znači "skriveno"
      }));

      setColumnsValues(valueList);

      // Sakrij kolone na osnovu `finalColumnVisibility`
      setTimeout(() => {
        if (tableRef.current) {
          columns.forEach((col) => {
            if (finalColumnVisibility[col.field]) {
              tableRef.current.hideColumn(col.field);
            } else {
              tableRef.current.showColumn(col.field);
            }
          });
        }
      }, 500);
    }
  }, [columns, finalColumnVisibility, tableRef]);

  // ✅ Funkcija koja omogućava korisniku da menja vidljivost kolona ručno
  const handleChange = (e) => {
    const field = e.target.name;

    updateColumnVisibility((prevState) => {
      const newState = { ...prevState, [field]: !prevState[field] };

      // Ažuriraj state kolona za checkbox listu
      const updatedColumns = columnsValues.map((col) =>
        col.name === field ? { ...col, value: !col.value } : col,
      );

      setColumnsValues(updatedColumns);

      if (tableRef.current) {
        if (!newState[field]) {
          console.log(`✅ Prikazujem kolonu: ${field}`);
          tableRef.current.showColumn(field);
        } else {
          console.log(`❌ Sakrivam kolonu: ${field}`);
          tableRef.current.hideColumn(field);
        }
      }

      return newState;
    });
  };

  // ✅ Zatvori meni kada korisnik klikne van njega
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.container} ref={containerRef}>
      <div
        className={`${styles.button} a-solid fa-table-columns`}
        onClick={() => setOpen(!open)}
      >
        <i className="fas fa-columns" />
        <span className={styles.text}>Kolone</span>
      </div>
      <CheckList handleChange={handleChange} data={columnsValues} show={open} />
    </div>
  );
};

export default HideColumns;
